import { createListenerMiddleware, isAnyOf } from '@reduxjs/toolkit'
import { setEnrollDetail, setFormNextButtonDisabled, setReduxValue } from '.'
import { handleFormInput, handleFormNextStep, handleStep2Button } from './event'

export const listenerMiddlewareElearningEnroll = createListenerMiddleware()

listenerMiddlewareElearningEnroll.startListening({
  matcher: isAnyOf(
    setEnrollDetail,
    setReduxValue // ✅ ติ๊ก checkbox consent (ถ้าอยู่ใน currentState)
  ),
  effect: async (action, listenerApi) => {
    const { index, obj } = action.payload
    const originalState = listenerApi.getOriginalState().eLearningEnroll
    const currentState = listenerApi.getState().eLearningEnroll

    const enrollIndex = typeof index !== 'undefined' ? 0 : 0

    if (obj === 'idCardNo' || obj === 'mobileNo') {
      listenerApi.dispatch(
        setReduxValue({ index: 'duplicatedError', value: [] })
      )
    }

    await handleFormInput(currentState, originalState, enrollIndex, listenerApi)
    await handleFormNextStep(
      currentState,
      originalState,
      enrollIndex,
      listenerApi
    )
  },
})

listenerMiddlewareElearningEnroll.startListening({
  actionCreator: setFormNextButtonDisabled,
  effect: async (action, listenerApi) => {
    handleStep2Button(listenerApi)
  },
})
